import { createTheme } from "@mui/material";

/**
 * MUI theme aligned with design tokens from tokens.css.
 *
 * MUI's createTheme() evaluates values at init time, so CSS custom properties
 * can't be used directly in palette/typography. Instead we keep the Maneno
 * defaults here and document the token mapping. The Griffle skin overrides MUI
 * component styles via CSS (`.griffle-page .Mui*` selectors in main.css).
 */

const tokens = {
  accent: "#3b82f6", // --color-accent
  accentHover: "#2563eb", // --color-accent-hover
  border: "#e2e8f0", // --color-border
  ink: "#0f172a", // --color-ink
  inkMuted: "#64748b", // --color-ink-muted
  surfaceHover: "#f1f5f9", // --color-surface-hover
  fontBody: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', // --font-body
  borderRadius: "8px" // --border-radius
};

export const muiTheme = createTheme({
  typography: {
    fontFamily: tokens.fontBody
  },
  palette: {
    primary: { main: tokens.accent }
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: tokens.borderRadius,
          height: "48px",
          boxSizing: "border-box",

          "&:hover": {
            ".MuiOutlinedInput-notchedOutline": {
              borderColor: tokens.accent
            }
          },

          ".MuiOutlinedInput-notchedOutline": {
            borderColor: tokens.border,
            borderWidth: "1px"
          },

          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: tokens.accent,
            borderWidth: "2px"
          },

          ".MuiSelect-icon": {
            width: "24px",
            height: "24px",
            color: tokens.inkMuted
          }
        }
      }
    },
    MuiPopover: {
      styleOverrides: {
        root: {
          zIndex: 11300
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: tokens.surfaceHover
          },
          "&.Mui-selected, &.Mui-selected:hover": {
            backgroundColor: tokens.accent,
            color: "white"
          }
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: tokens.borderRadius,
          boxSizing: "border-box"
        }
      }
    }
  }
});
